/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type {
  GetQuizUserIdsByCountryCodeParams,
  QuizsetSearchReq,
  SearchResponseListSearchQuizsetRes,
  SetQuizUserInfoReq,
  SuccessBodyAuthRes,
  SuccessBodyListString,
  SuccessBodyMyProfileRes,
  SuccessBodyQuizUserInfoRes,
  SuccessBodySeoSitemapPageString,
  SuccessBodySetQuizUserTypeResponse,
  UpdateQuizUserReq,
} from '.././_model';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const searchUserPublicQuizsets = (
  userId: string,
  quizsetSearchReq: BodyType<QuizsetSearchReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SearchResponseListSearchQuizsetRes>(
    {
      url: `/users/${userId}/quizsets`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetSearchReq,
      signal,
    },
    options,
  );
};

export const getSearchUserPublicQuizsetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchUserPublicQuizsets>>,
    TError,
    { userId: string; data: BodyType<QuizsetSearchReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchUserPublicQuizsets>>,
  TError,
  { userId: string; data: BodyType<QuizsetSearchReq> },
  TContext
> => {
  const mutationKey = ['searchUserPublicQuizsets'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchUserPublicQuizsets>>,
    { userId: string; data: BodyType<QuizsetSearchReq> }
  > = props => {
    const { userId, data } = props ?? {};

    return searchUserPublicQuizsets(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchUserPublicQuizsetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchUserPublicQuizsets>>
>;
export type SearchUserPublicQuizsetsMutationBody = BodyType<QuizsetSearchReq>;
export type SearchUserPublicQuizsetsMutationError = ErrorType<unknown>;

export const useSearchUserPublicQuizsets = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchUserPublicQuizsets>>,
      TError,
      { userId: string; data: BodyType<QuizsetSearchReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchUserPublicQuizsets>>,
  TError,
  { userId: string; data: BodyType<QuizsetSearchReq> },
  TContext
> => {
  const mutationOptions = getSearchUserPublicQuizsetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const searchMyQuizsets = (
  quizsetSearchReq: BodyType<QuizsetSearchReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SearchResponseListSearchQuizsetRes>(
    {
      url: `/users/myquiz`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetSearchReq,
      signal,
    },
    options,
  );
};

export const getSearchMyQuizsetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchMyQuizsets>>,
    TError,
    { data: BodyType<QuizsetSearchReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchMyQuizsets>>,
  TError,
  { data: BodyType<QuizsetSearchReq> },
  TContext
> => {
  const mutationKey = ['searchMyQuizsets'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchMyQuizsets>>,
    { data: BodyType<QuizsetSearchReq> }
  > = props => {
    const { data } = props ?? {};

    return searchMyQuizsets(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchMyQuizsetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchMyQuizsets>>
>;
export type SearchMyQuizsetsMutationBody = BodyType<QuizsetSearchReq>;
export type SearchMyQuizsetsMutationError = ErrorType<unknown>;

export const useSearchMyQuizsets = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchMyQuizsets>>,
      TError,
      { data: BodyType<QuizsetSearchReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchMyQuizsets>>,
  TError,
  { data: BodyType<QuizsetSearchReq> },
  TContext
> => {
  const mutationOptions = getSearchMyQuizsetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const setQuizUserInfo = (
  setQuizUserInfoReq: BodyType<SetQuizUserInfoReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodySetQuizUserTypeResponse>(
    {
      url: `/users/info`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: setQuizUserInfoReq,
    },
    options,
  );
};

export const getSetQuizUserInfoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setQuizUserInfo>>,
    TError,
    { data: BodyType<SetQuizUserInfoReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setQuizUserInfo>>,
  TError,
  { data: BodyType<SetQuizUserInfoReq> },
  TContext
> => {
  const mutationKey = ['setQuizUserInfo'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setQuizUserInfo>>,
    { data: BodyType<SetQuizUserInfoReq> }
  > = props => {
    const { data } = props ?? {};

    return setQuizUserInfo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetQuizUserInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof setQuizUserInfo>>
>;
export type SetQuizUserInfoMutationBody = BodyType<SetQuizUserInfoReq>;
export type SetQuizUserInfoMutationError = ErrorType<unknown>;

export const useSetQuizUserInfo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setQuizUserInfo>>,
      TError,
      { data: BodyType<SetQuizUserInfoReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setQuizUserInfo>>,
  TError,
  { data: BodyType<SetQuizUserInfoReq> },
  TContext
> => {
  const mutationOptions = getSetQuizUserInfoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 사용자의 이름, 회원 정보, 마케팅 동의 정보를 수정합니다.
 * @summary 사용자 정보 수정
 */
export const editQuizUser = (
  updateQuizUserReq: BodyType<UpdateQuizUserReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyAuthRes>(
    {
      url: `/users/edit`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateQuizUserReq,
    },
    options,
  );
};

export const getEditQuizUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editQuizUser>>,
    TError,
    { data: BodyType<UpdateQuizUserReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editQuizUser>>,
  TError,
  { data: BodyType<UpdateQuizUserReq> },
  TContext
> => {
  const mutationKey = ['editQuizUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editQuizUser>>,
    { data: BodyType<UpdateQuizUserReq> }
  > = props => {
    const { data } = props ?? {};

    return editQuizUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditQuizUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof editQuizUser>>
>;
export type EditQuizUserMutationBody = BodyType<UpdateQuizUserReq>;
export type EditQuizUserMutationError = ErrorType<unknown>;

/**
 * @summary 사용자 정보 수정
 */
export const useEditQuizUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof editQuizUser>>,
      TError,
      { data: BodyType<UpdateQuizUserReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof editQuizUser>>,
  TError,
  { data: BodyType<UpdateQuizUserReq> },
  TContext
> => {
  const mutationOptions = getEditQuizUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getQuizUserInfo = (
  userId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizUserInfoRes>(
    { url: `/users/${userId}/info`, method: 'GET', signal },
    options,
  );
};

export const getGetQuizUserInfoQueryKey = (userId: string) => {
  return [`/users/${userId}/info`] as const;
};

export const getGetQuizUserInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizUserInfo>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizUserInfoQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizUserInfo>>> = ({
    signal,
  }) => getQuizUserInfo(userId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizUserInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizUserInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizUserInfo>>
>;
export type GetQuizUserInfoQueryError = ErrorType<unknown>;

export function useGetQuizUserInfo<
  TData = Awaited<ReturnType<typeof getQuizUserInfo>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizUserInfo>>,
          TError,
          Awaited<ReturnType<typeof getQuizUserInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizUserInfo<
  TData = Awaited<ReturnType<typeof getQuizUserInfo>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizUserInfo>>,
          TError,
          Awaited<ReturnType<typeof getQuizUserInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizUserInfo<
  TData = Awaited<ReturnType<typeof getQuizUserInfo>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizUserInfo<
  TData = Awaited<ReturnType<typeof getQuizUserInfo>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizUserInfoQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizUserInfoSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizUserInfo>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuizUserInfoQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuizUserInfo>>> = ({
    signal,
  }) => getQuizUserInfo(userId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizUserInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizUserInfoSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizUserInfo>>
>;
export type GetQuizUserInfoSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizUserInfoSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserInfo>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizUserInfoSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserInfo>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizUserInfoSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserInfo>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizUserInfoSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserInfo>>,
  TError = ErrorType<unknown>,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetQuizUserInfoSuspenseQueryOptions(userId, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuizUserSitemapCountries = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListString>(
    { url: `/users/sitemap-countries`, method: 'GET', signal },
    options,
  );
};

export const getGetQuizUserSitemapCountriesQueryKey = () => {
  return [`/users/sitemap-countries`] as const;
};

export const getGetQuizUserSitemapCountriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizUserSitemapCountriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizUserSitemapCountries>>
  > = ({ signal }) => getQuizUserSitemapCountries(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizUserSitemapCountriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizUserSitemapCountries>>
>;
export type GetQuizUserSitemapCountriesQueryError = ErrorType<unknown>;

export function useGetQuizUserSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
          TError,
          Awaited<ReturnType<typeof getQuizUserSitemapCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizUserSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
          TError,
          Awaited<ReturnType<typeof getQuizUserSitemapCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizUserSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizUserSitemapCountries<
  TData = Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizUserSitemapCountriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizUserSitemapCountriesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizUserSitemapCountriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizUserSitemapCountries>>
  > = ({ signal }) => getQuizUserSitemapCountries(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizUserSitemapCountriesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizUserSitemapCountries>>
>;
export type GetQuizUserSitemapCountriesSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizUserSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizUserSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizUserSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizUserSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions =
    getGetQuizUserSitemapCountriesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 인증된 사용자의 상세 프로필 정보를 조회합니다. (개인정보 포함: 이메일, 휴대폰, 마케팅 동의)
 * @summary 본인 프로필 상세 조회
 */
export const getMyProfile = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyMyProfileRes>(
    { url: `/users/me`, method: 'GET', signal },
    options,
  );
};

export const getGetMyProfileQueryKey = () => {
  return [`/users/me`] as const;
};

export const getGetMyProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProfile>>> = ({
    signal,
  }) => getMyProfile(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyProfile>>
>;
export type GetMyProfileQueryError = ErrorType<unknown>;

export function useGetMyProfile<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyProfile>>,
          TError,
          Awaited<ReturnType<typeof getMyProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyProfile<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyProfile>>,
          TError,
          Awaited<ReturnType<typeof getMyProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyProfile<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary 본인 프로필 상세 조회
 */

export function useGetMyProfile<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMyProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMyProfileSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMyProfile>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProfile>>> = ({
    signal,
  }) => getMyProfile(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyProfileSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyProfile>>
>;
export type GetMyProfileSuspenseQueryError = ErrorType<unknown>;

export function useGetMyProfileSuspense<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyProfileSuspense<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyProfileSuspense<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
/**
 * @summary 본인 프로필 상세 조회
 */

export function useGetMyProfileSuspense<
  TData = Awaited<ReturnType<typeof getMyProfile>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetMyProfileSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getQuizUserIdsByCountryCode = (
  params: GetQuizUserIdsByCountryCodeParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodySeoSitemapPageString>(
    { url: `/users/ids-by-countrycode`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizUserIdsByCountryCodeQueryKey = (
  params: GetQuizUserIdsByCountryCodeParams,
) => {
  return [`/users/ids-by-countrycode`, ...(params ? [params] : [])] as const;
};

export const getGetQuizUserIdsByCountryCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizUserIdsByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizUserIdsByCountryCodeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>
  > = ({ signal }) =>
    getQuizUserIdsByCountryCode(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizUserIdsByCountryCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>
>;
export type GetQuizUserIdsByCountryCodeQueryError = ErrorType<unknown>;

export function useGetQuizUserIdsByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizUserIdsByCountryCodeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
          TError,
          Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizUserIdsByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizUserIdsByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
          TError,
          Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuizUserIdsByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizUserIdsByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetQuizUserIdsByCountryCode<
  TData = Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizUserIdsByCountryCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQuizUserIdsByCountryCodeQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetQuizUserIdsByCountryCodeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizUserIdsByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizUserIdsByCountryCodeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>
  > = ({ signal }) =>
    getQuizUserIdsByCountryCode(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetQuizUserIdsByCountryCodeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>
>;
export type GetQuizUserIdsByCountryCodeSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizUserIdsByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizUserIdsByCountryCodeParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizUserIdsByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizUserIdsByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuizUserIdsByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizUserIdsByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetQuizUserIdsByCountryCodeSuspense<
  TData = Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizUserIdsByCountryCodeParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizUserIdsByCountryCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetQuizUserIdsByCountryCodeSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
